import type { Scene } from '@hoverinc/rendering-compositor-react';
import {
  CompositorProvider,
  DEFAULT_SCALE,
} from '@hoverinc/rendering-compositor-react';
import React from 'react';

import type { HiDefRenderingFile } from 'src/shared/graphql/generated';

const allowedRegionList = ['WALLS', 'ROOFS', 'TRIM'];

const createCompositorScene = (file: HiDefRenderingFile): Scene => ({
  beauty: file?.image?.blobUrl || '',
  uv: file?.uvPass?.blobUrl || '',
  matte: file?.cryptomattePass?.blobUrl || '',
  lighting: file?.combinedLightingPass?.blobUrl || '',
  allowedRegions: file?.cryptomatteRegions?.regions
    .filter(({ category }) => allowedRegionList.includes(category))
    .map(({ regionId }) => regionId),
  aspectRatio: 16 / 9,
  scale: file?.textureScale ?? DEFAULT_SCALE,
});

const InteractiveRenderingDataProvider = ({
  children,
  onClick,
  onLoadError,
  renderingFile,
}: {
  children: React.ReactNode;
  onLoadError: (error: Error) => void;
  onClick: (regionId: string) => void;
  renderingFile: HiDefRenderingFile | undefined;
}) => {
  const scene = renderingFile
    ? createCompositorScene(renderingFile)
    : undefined;

  return (
    <CompositorProvider
      onClick={onClick}
      onLoadError={onLoadError}
      scene={scene}
      sizeMode="contain"
    >
      {children}
    </CompositorProvider>
  );
};

export { InteractiveRenderingDataProvider };
